export const mockFeaturedBookies = [
  {
    id: 'bf8788ghmrv8bg1f28ig',
    code: 'BET365',
    name: 'Bet365',
    logo_url: {
      default: 'https://cdn.tipsterchat.com/bookies/logos/default/Bet365.png',
      highlighted:
        'https://cdn.tipsterchat.com/bookies/logos/highlighted/Bet365.png',
      ios: 'https://cdn.tipsterchat.com/bookies/logos/Bet365.png',
      android: 'https://cdn.tipsterchat.com/bookies/logos/Bet365.svg',
      web: 'https://cdn.tipsterchat.com/bookies/logos/Bet365.svg',
    },
    is_active: true,
    url: 'https://www.bet365.com/olp/open-account?affiliate=365_00925473',
  },
  {
    id: 'c0enc0k2euso1213g640',
    code: 'PLAY_DO_IT',
    name: 'Play Do It',
    logo_url: {
      default: 'https://cdn.tipsterchat.com/bookies/logos/default/Playdoit.png',
      highlighted:
        'https://cdn.tipsterchat.com/bookies/logos/highlighted/Playdoit.png',
      ios: 'https://cdn.tipsterchat.com/bookies/logos/PlayDoIt.png',
      android: 'https://cdn.tipsterchat.com/bookies/logos/PlayDoIt.svg',
      web: 'https://cdn.tipsterchat.com/bookies/logos/PlayDoIt.svg',
    },
    is_active: true,
    url: '',
  },
  {
    id: 'cd2u9vn96j4e7dhn3o80',
    code: 'TONYBET',
    name: 'Tonybet',
    logo_url: {
      default: 'https://cdn.tipsterchat.com/bookies/logos/default/TonyBet.png',
      highlighted:
        'https://cdn.tipsterchat.com/bookies/logos/highlighted/TonyBet.png',
      ios: 'https://cdn.tipsterchat.com/bookies/logos/Tonybet.png',
      android: 'https://cdn.tipsterchat.com/bookies/logos/Tonybet.svg',
      web: 'https://cdn.tipsterchat.com/bookies/logos/Tonybet.svg',
    },
    is_active: true,
    url: '',
  },
];

export const mockBookies = {
  bookies: [
    {
      id: 'biefnarp0dp6sqioj4g0',
      code: 'PINNACLE',
      name: 'Pinnacle Sports',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Pinnacle.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Pinnacle.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Pinnacle.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Pinnacle.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Pinnacle.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'bf8788ghmrv8bg1f28ig',
      code: 'BET365',
      name: 'Bet365',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Bet365.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Bet365.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Bet365.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Bet365.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Bet365.svg',
      },
      is_active: true,
      url: 'https://www.bet365.com/olp/open-account?affiliate=365_00925473',
    },
    {
      id: 'bf8788ghmrv8bg1f28kg',
      code: 'BWIN',
      name: 'Bwin',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Bwin.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Bwin.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Bwin.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Bwin.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'bf8788ghmrv8bg1f28jg',
      code: 'WILLIAM_HILL',
      name: 'William Hill',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/WilliamHill.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/WilliamHill.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/WilliamHill.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/WilliamHill.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'biefnbbp0dp6sqioj4i0',
      code: 'MARATHON',
      name: 'Marathon',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Marathon.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Marathon.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Marathon.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Marathon.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'bf8788ghmrv8bg1f28l0',
      code: '888',
      name: '888Sport',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/888.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/888.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/888.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/888.svg',
      },
      is_active: true,
      url: 'https://mmwebhandler.aff-online.com/C/43477?sr=1698901',
    },
    {
      id: 'bf8788ghmrv8bg1f28k0',
      code: 'BETWAY',
      name: 'Betway',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Betway.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Betway.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Betway.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Betway.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Betway.svg',
      },
      is_active: true,
      url: 'https://betway.es/?s=bw205743\u0026a=bwadid75222',
    },
    {
      id: 'biefnbrp0dp6sqioj4jg',
      code: 'BETFAIR',
      name: 'Betfair',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Betfair.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Betfair.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Betfair.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Betfair.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Betfair.svg',
      },
      is_active: true,
      url: 'https://ads.betfair.com/redirect.aspx?pid=3661583\u0026bid=3604',
    },
    {
      id: 'boncolv2s2mbuo758a30',
      code: 'CODERE',
      name: 'Codere',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Codere.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Codere.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Codere.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Codere.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Codere.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'boncomf2s2mbtlkkm790',
      code: 'KIROL_BET',
      name: 'Kirol Bet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/KirolBet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/KirolBet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/KirolBet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/KirolBet.svg',
      },
      is_active: true,
      url: 'https://adsff.kirolbet.com/redirect.aspx?pid=3978\u0026bid=1492',
    },
    {
      id: 'boncomn2s2mbsn1ncifg',
      code: 'LEO_VEGAS',
      name: 'Leo Vegas',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/LeoVegas.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/LeoVegas.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/LeoVegas.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/LeoVegas.svg',
      },
      is_active: true,
      url: 'https://ads.leovegas.com/redirect.aspx?pid=3654206\u0026bid=15792',
    },
    {
      id: 'boncomv2s2mbri6pll4g',
      code: 'MERKUR',
      name: 'Merkur',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Merkur.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Merkur.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Merkur.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Merkur.svg',
      },
      is_active: false,
      url: 'https://wlmerkurpartners.adsrv.eacdn.com/C.ashx?btag=a_4486b_1307c_\u0026affid=2662\u0026siteid=4486\u0026adid=1307\u0026c=',
    },
    {
      id: 'boncon72s2mbqev3r0gg',
      code: 'SPORTIUM',
      name: 'Sportium',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Sportium.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Sportium.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Sportium.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Sportium.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'bonconf2s2mbpast6iv0',
      code: 'STAR_VEGAS',
      name: 'Star Vegas',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/StarVegas.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/StarVegas.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/StarVegas.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/StarVegas.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'biefnb3p0dp6sqioj4gg',
      code: 'BETFAIR_EXCHANGE',
      name: 'Betfair Exchange',
      logo_url: { default: '', highlighted: '', ios: '', android: '', web: '' },
      is_active: false,
      url: '',
    },
    {
      id: 'biefnbbp0dp6sqioj4h0',
      code: 'CORAL',
      name: 'Coral',
      logo_url: { default: '', highlighted: '', ios: '', android: '', web: '' },
      is_active: false,
      url: '',
    },
    {
      id: 'biefnbbp0dp6sqioj4hg',
      code: 'SPORTINGBET',
      name: 'SportingBet',
      logo_url: { default: '', highlighted: '', ios: '', android: '', web: '' },
      is_active: false,
      url: '',
    },
    {
      id: 'btrko7n96j4ala3kaj20',
      code: 'BETFRED',
      name: 'Betfred',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Betfred.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Betfred.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Betfred.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Betfred.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'btrko7v96j4alq9hqd00',
      code: 'POKERSTARS',
      name: 'Pokerstars',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Pokerstars.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Pokerstars.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Pokerstars.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Pokerstars.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'btrkv9n96j4b3had2fa0',
      code: 'WINAMAX',
      name: 'Winamax',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Winamax.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Winamax.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Winamax.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Winamax.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Winamax.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'btrkv3796j4b59u0q50g',
      code: 'BETHARD',
      name: 'Bethard',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Bethard.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Bethard.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Bethard.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Bethard.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'btrkv3f96j4b5pm9hseg',
      code: 'INTERWETTEN',
      name: 'Interwetten',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Interwetten.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Interwetten.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Interwetten.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Interwetten.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'btrkv3f96j4b49r4fbt0',
      code: '1XBET',
      name: '1xBET',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/1xBET.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/1xBET.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/1xBET.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/1xBET.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'btrkv3n96j4b4pve32gg',
      code: 'LONDON_BETTING_SHOP',
      name: 'London Betting Shop',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/LondonBS.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/LondonBettingShop.png',
        android:
          'https://cdn.tipsterchat.com/bookies/logos/LondonBettingShop.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/LondonBettingShop.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'buh838v96j4fd26f7jq0',
      code: 'MONDOBETS',
      name: 'Mondobets',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Mondobets.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Mondobets.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Mondobets.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Mondobets.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'buh839f96j4fdi67cke0',
      code: 'RETABET',
      name: 'Retabet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Retabet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Retabet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Retabet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Retabet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c0enbpk2euso30n50d2g',
      code: 'CALIENTE',
      name: 'Caliente',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Caliente.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Caliente.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Caliente.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Caliente.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c0enbq42euso3uba7q9g',
      code: 'PLAY_CITY',
      name: 'Play City',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/PlayCity.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Playcity.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Playcity.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Playcity.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c0enc0k2euso1213g640',
      code: 'PLAY_DO_IT',
      name: 'Play Do It',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Playdoit.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Playdoit.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/PlayDoIt.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/PlayDoIt.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/PlayDoIt.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c0enc0s2euso1oi7dqq0',
      code: 'BETCRIS',
      name: 'BetCris',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Betcris.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Betcris.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Betcris.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Betcris.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Betcris.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c2jujhs2euso7m9cv8kg',
      code: 'DIAMANTE',
      name: 'Diamante',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Diamante.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Diamante.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Diamante.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Diamante.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c2jujic2euso6cr43pcg',
      code: 'INSTABET',
      name: 'Instabet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Instabet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Instabet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Instabet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Instabet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c2n50es2eusp6anosp0g',
      code: 'JOKERBET',
      name: 'JokerBet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/JokerBet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/JokerBet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/JokerBet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/JokerBet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c2n50fc2eusp56lcfg7g',
      code: 'BETMEXICO',
      name: 'BetMexico',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/BetMexico.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/BetMexico.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/BetMexico.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/BetMexico.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c3hie9n96j4c8j1et6b0',
      code: 'SPORTSBETIO',
      name: 'Sportsbet.io',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Sportsbetio.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Sportsbetio.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Sportsbetio.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Sportsbetio.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c3hie9n96j4c8tq53b0g',
      code: 'BETANO',
      name: 'Betano',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Betano.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Betano.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Betano.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Betano.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Betano.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c4ss75v96j4f59tleeqg',
      code: 'LUCKIA',
      name: 'Luckia',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Luckia.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Luckia.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Luckia.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Luckia.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c7g3clv96j4fj2m28ar0',
      code: 'MERIDIANBET',
      name: 'Meridianbet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Meridianbet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Meridianbet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Meridianbet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Meridianbet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c7t7f0796j488grsg2gg',
      code: 'EFBET',
      name: 'Efbet',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Efbet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Efbet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Efbet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Efbet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'c85vg8n96j4d3en73m3g',
      code: 'STRENDUS',
      name: 'Strendus',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Strendus.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Strendus.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Strendus.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Strendus.png',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Strendus.png',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cad2q3796j4fkgputv0g',
      code: 'BET_PIX_365',
      name: 'BetPix365',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/BetPix365.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/BetPix365.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/BetPix365.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/BetPix365.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/BetPix365.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cao50os4s2672913e00g',
      code: 'GANA_BET',
      name: 'GanaBet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/GanaBet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/GanaBet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/GanaBet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/GanaBet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cao50os4s2672913e010',
      code: 'GOLDEN_PARK',
      name: 'GoldenPark',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/GoldenPark.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/GoldenPark.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/GoldenPark.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/GoldenPark.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cb2ljss4s263mevt9l60',
      code: 'TEAM_MEXICO',
      name: 'Team México',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/TeamMexico.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/TeamMexico.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/TeamMexico.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/TeamMexico.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cbueajk4s26buloqr29g',
      code: 'MEGAPARI',
      name: 'Megapari',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Megapari.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Megapari.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/megapari.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/megapari.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/megapari.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cbueajk4s26buloqr2a0',
      code: 'BET7',
      name: 'Bet7',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Bet7.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/Bet7.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/bet7.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/bet7.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/bet7.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cd2u9vn96j4e7dhn3o80',
      code: 'TONYBET',
      name: 'Tonybet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/TonyBet.png',
        highlighted:
          'https://cdn.tipsterchat.com/bookies/logos/highlighted/TonyBet.png',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/Tonybet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/Tonybet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/Tonybet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cd4m7u796j44pcl1egl0',
      code: 'GGBET',
      name: 'GGBET',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/GGBet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/ggbet.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/ggbet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/ggbet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cdhvb6s4s2671mckpmbg',
      code: 'ESPORTSBET',
      name: 'eSportsBet',
      logo_url: {
        default:
          'https://cdn.tipsterchat.com/bookies/logos/default/Esportsbet.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/logo_esportsbet.png',
        android:
          'https://cdn.tipsterchat.com/bookies/logos/logo_esportsbet.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/logo_esportsbet.svg',
      },
      is_active: true,
      url: '',
    },
    {
      id: 'cdhvb6s4s2671mckpmc0',
      code: 'PASTON',
      name: 'Paston',
      logo_url: {
        default: 'https://cdn.tipsterchat.com/bookies/logos/default/Paston.png',
        highlighted: '',
        ios: 'https://cdn.tipsterchat.com/bookies/logos/logo_paston.png',
        android: 'https://cdn.tipsterchat.com/bookies/logos/logo_paston.svg',
        web: 'https://cdn.tipsterchat.com/bookies/logos/logo_paston.svg',
      },
      is_active: true,
      url: '',
    },
  ],
};
